/**
 * Customer State Atoms for Jotai (Co-located with Screens)
 */
import { atom } from 'jotai';

export type CustomerCategory = 'main' | 'dependent';
export type CustomerLabel = 'vip' | 'potential' | 'loyal' | 'new' | 'family' | 'business' | 'consulting';

export interface CustomerState {
  id: string;
  name: string;
  category: CustomerCategory;
  dependentsCount: number;
  dob: string;
  age: number;
  gender: 'Nam' | 'Nữ';
  phone: string;
  email: string;
  labels: CustomerLabel[];
  occupation: string;
  createdAt: string;
}

/**
 * Holds the currently selected customer when navigating from M15 to M06 or M16
 */
export const selectedCustomerAtom = atom<CustomerState | null>(null);

/**
 * Holds the currently selected product ID (default: 'XUM')
 */
export const selectedProductIdAtom = atom<string>('XUM');
